// extracted by mini-css-extract-plugin
export default {"grid":"setting-selector_grid__UJkIE","button":"setting-selector_button__EWYbA","title":"setting-selector_title__rV9mT","description":"setting-selector_description__26JgN"};